import React from "react";
import ReactDom from "react-dom";
import { Rates, BookingEngine } from "../../hotel_integration_modules/index";
import I18n from "../../translations/i18n";
import { BiPlus } from "react-icons/bi";
import styled from "styled-components";

type RatesMessagingProps = {
  bookingEngine: BookingEngine;
  rate: Rates;
  currency: string;
  locale: string;
  setMessagingHeight: (a: number) => void;
  setMessagingCoordinates: (a: [number, number]) => void;
  setOuterAccordionExpanded: (e: any) => void;
  widgetMobileAtWidth: number;
  setShowHoverOver: (e: boolean) => void;
  showHoverOver: boolean;
  setHoverOverSide: (a: "left" | "right") => void;
  showMessaging: boolean;
  onOpenMobileModal: (rate: Rates) => void;
};

const MessageContainer = styled.div`
  position: relative;
  width: max-content;
  font-family: ${({ theme }) => theme.primaryFont};
`;

const EarnMessaging = styled.div`
  margin-top: 4px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  color: ${({ theme }) => theme.primaryColor} !important;
  outline: 0 !important;
  &:focus {
    text-decoration: underline;
  }
`;

const IconContainer = styled.span`
  position: relative;
  top: 2px;
`;

const RatesMessaging = ({
  bookingEngine,
  rate,
  currency,
  locale,
  setOuterAccordionExpanded,
  widgetMobileAtWidth,
  showHoverOver,
  setShowHoverOver,
  setMessagingHeight,
  setMessagingCoordinates,
  setHoverOverSide,
  showMessaging,
  onOpenMobileModal,
}: RatesMessagingProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const { innerWidth: width } = window;

    if (bookingEngine.name === "selfbook") {
      setOuterAccordionExpanded(true);
      sessionStorage.setItem("gbWidgetExpanded", "true");
    }

    if (width < widgetMobileAtWidth) {
      onOpenMobileModal(rate);
      return;
    }

    if (bookingEngine.name === "bobw") {
      setShowHoverOver(!showHoverOver);
    } else {
      setShowHoverOver(true);
    }
  };

  const dontShowRewardsValue =
    bookingEngine.hotel.widgetIdentifier === "hotelaliceatatlanticbeach" ||
    bookingEngine.hotel.widgetIdentifier === "marquisloscabos" ||
    (bookingEngine.hotel.widgetIdentifier === "bobw_hotels" &&
      Number(rate.rewardsAmount) === 0);

  const handleMouseEnter = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (window.innerWidth > 768) {
      const messagingRect = e.currentTarget.getBoundingClientRect();
      setMessagingHeight(messagingRect.height);

      const rect = e.currentTarget.getBoundingClientRect();
      let offsetX;
      let offsetY = rect.y + window.scrollY + rect.height / 2;

      if (rect.x + rect.width + window.scrollX + 319 > window.innerWidth) {
        setHoverOverSide("left");
        offsetX = rect.x + window.scrollX;
      } else {
        setHoverOverSide("right");
        offsetX = rect.x + rect.width + window.scrollX;
      }

      setMessagingCoordinates([offsetX, offsetY]);
    }

    if (bookingEngine.name === "bobw") return;

    setShowHoverOver(true);
  };

  const handleMouseLeave = () => {
    if (bookingEngine.name === "bobw") return;
    setShowHoverOver(false);
  };

  if (rate.shouldDisplay && showMessaging) {
    return ReactDom.createPortal(
      <MessageContainer className="message-container">
        <EarnMessaging
          className="gb-banner"
          tabIndex={0}
          onClick={handleClick}
          onMouseOver={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <IconContainer className="icon-container">
            <BiPlus />
          </IconContainer>
          {I18n.t(
            "views.hotel_integration.components.rates_messaging.earn",
            {
              rewards: dontShowRewardsValue
                ? "15%"
                : `${currency}${rate.rewardsAmount}`,
              locale: `${locale}`,
            }
          )}
        </EarnMessaging>
      </MessageContainer>,
      rate.target as Element
    );
  }

  return null;
};

export default RatesMessaging;
